import { getLocalizedText } from "../utils/i18n"

export const lovKeyOnetimePaymentMethodCreditCard = '1'
export const lovKeyOnetimePaymentMethodPaypay = '2'
export const lovKeyOnetimePaymentMethodPaid = '3'

export const stoppedStatus = '一時停止'
export const rejectedStatus = '審査否決'
export const STATUS_REGISTERED = 0;
export const STATUS_ENABLED = 1;
export const STATUS_STOPPED = 2;
export const STATUS_PENDING_REVIEW = 3;
export const STATUS_REJECTED = 4;
export const STATUS_WITHDRAWN = 90;

export const PAYMENT_METHOD_INVOICE = '2';

export const creditCardPayment = getLocalizedText('master.paymentMethod.1')
export const invoicePayment = getLocalizedText('master.paymentMethod.2')
